/**
 * Maps internal model names to their display names in the UI.
 * Order matters: longer strings first to avoid partial replacements
 */
const MODEL_DISPLAY_NAME_MAP: Record<string, string> = {
  'ECMWF AIFS ENS': 'AIFS ENS',
  ECMWF_AIFS_ENS: 'AIFS_ENS',
  'ECMWF AIFS': 'AIFS',
  ECMWF_AIFS: 'AIFS',
};

const MODEL_TITLE_REMAP_IDS = new Set([
  'ECMWF_AIFS',
  'ECMWF_AIFS_ENS',
  'ECMWF AIFS',
]);

/**
 * Gets the display name for a model key or replaces model names within a string.
 * Handles both exact matches and partial replacements.
 * @param modelKey The model identifier or string containing model name (e.g., 'ECMWF_AIFS 06Z Fri NOV23')
 * @returns The string with model name replaced (e.g., 'AIFS 06Z Fri NOV23')
 */
export function getModelDisplayName(modelKey: string | undefined): string {
  if (!modelKey) {
    return '';
  }

  let result = modelKey;

  // Try to replace all known model names in the string
  // Process in order (longer strings first to avoid partial replacements)
  for (const [original, replacement] of Object.entries(
    MODEL_DISPLAY_NAME_MAP
  )) {
    if (result.includes(original)) {
      result = result.replace(original, replacement);
    }
  }

  return result;
}

/**
 * if present, removes 'ECMWF' from ECMWF AIFS model names
 * otherwise just returns the unchanged modelname
 */
export function remapModelTitle(modelId: string, modelName: string): string {
  if (!MODEL_TITLE_REMAP_IDS.has(modelId)) return modelName;
  return modelName.replace(/^ecmwf\s+/i, '');
}
